export * from "./msal"
export * from "./client"
export * from "./cache"
export const pageSize = 40;

import { Client } from './legacyClient'
import { PublicClientApplication } from "@azure/msal-browser";
import { msalGetToken } from './msal'

export const getApiClient = (baseUrl: string, domain: string, msalClient: PublicClientApplication): [Client, AbortController] => {
  const controller = new AbortController();
  const { signal } = controller;

  let client = new Client(baseUrl, {
    fetch: async (url: RequestInfo, init?: RequestInit) => {
      let token = await msalGetToken(domain, msalClient);

      if (init) {
        return await fetch(url, {
          ...init,
          headers: {
            ...init.headers,
            Authorization: `Bearer ${token}`,
          },
          signal
        });
      }
      else {
        return await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal
        });
      }
    }
  })

  return [client, controller]
}